import React, { useEffect, useState } from "react";
import {
  stuacademicyearlist,
  stuclasslist,
  studivisionlist,
} from "../../../services/master";
import { promotestudents, studentfilter, studentleft } from "../../../services/student";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { academylist } from "../../../services/admin";
import Select from "react-select";
import { AgGridReact } from "ag-grid-react";

const Promotestudent = () => {
  const [alist, setAList] = useState([]);
  const [classList, setClassList] = useState([]);
  const [seclist, setSecList] = useState([]);

  const [stuList, setStuList] = useState([]);

  const [fyear, setFYear] = useState("");
  const [fclass, setFClass] = useState("");
  const [fsection, setFSection] = useState("");
  const [fstudent, setFStudent] = useState([]);
  const [studentOptions, setStudentOptions] = useState([]);

  const [tyear, setTYear] = useState("");
  const [tclass, setTClass] = useState("");
  const [tsection, setTSection] = useState("");

  const [isAlumni, setIsAlumni] = useState(false);
  const [loading, setLoading] = useState(false);

  const [aclist, setAcList] = useState([]);
  const [acaid, setAcaID] = useState("");

  useEffect(() => {


    stuclasslist().then((res) => {
      if (res.status === true) {
        setClassList(res.data);
      }
    });
    studivisionlist().then((res) => {
      if (res.status === true) {
        setSecList(res.data);
      }
    });

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAcList(arr);
        }
      }
    });
    // listyear("");

    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
                listyear(arr[0]);
              }
            }

          }
        }
      });
    } else {
      listyear("");
    }

  }, []);

  useEffect(() => {
    if (fyear !== "" && fclass !== "" && fsection !== "") {
      setFStudent("");
      setStudentOptions([]);
      const temp = new FormData();
      temp.append("year", fyear);
      temp.append("class", fclass);
      temp.append("section", fsection);
      if (localStorage.getItem("Role") === "1" && acaid !== "") {
        temp.append("academy", acaid.value);
      }
      studentfilter(temp).then((res) => {
        if (res.status === true && res.data.details.length > 0) {
          setStudentOptions(
            res.data.details.map((s) => ({
              value: s.id,
              label: s.student_name + " (" + s.username + ")",
            }))
          );
        }
      });
    } else {
      setFStudent([]);
      setStudentOptions([]);
    }
  }, [fyear, fclass, fsection, acaid]);

  const [errmsg, setErrmsg] = useState("");
  function subpromote(e) {
    e.preventDefault();
    setErrmsg("");
    let valid = "";
    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        setErrmsg("Please Select Academy");
        valid = "Please Select Academy";
      }
    } else {
      valid = "";
    }
    if (valid === "") {
      if (fyear !== "") {
        if (fclass !== "") {
          if (fsection !== "") {
            if (tyear !== "") {
              if (tclass !== "") {
                if (tsection !== "") {
                  const temp = new FormData();
                  temp.append("year", fyear);
                  temp.append("class", fclass);
                  temp.append("section", fsection);
                  if (localStorage.getItem("Role") === "1" && acaid !== "") {
                    temp.append("academy", acaid.value);
                  }
                  studentfilter(temp).then((res) => {
                    if (res.status === true) {
                      if (res.data.details.length > 0) {
                        const filteredCount = fstudent.length > 0
                          ? fstudent.length
                          : res.data.details.length;
                        Swal.fire({
                          html:
                            "<h3>Are you sure want to promote?</h3> <br/> <h4> Total Students " +
                            filteredCount +
                            "</h4>",
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#19b159",
                          cancelButtonColor: "#6259ca",
                          confirmButtonText: "Yes",
                          allowOutsideClick: false,
                        }).then((result) => {
                          if (result.isConfirmed) {
                            setLoading(true);
                            const temp1 = new FormData();
                            temp1.append("year", fyear);
                            temp1.append("class", fclass);
                            temp1.append("section", fsection);
                            temp1.append("t_year", tyear);
                            temp1.append("t_class", tclass);
                            temp1.append("t_section", tsection);
                            temp1.append("user_id", localStorage.getItem("UID"));
                            if (fstudent.length > 0) {
                              fstudent.forEach((s) =>
                                temp1.append("student_ids[]", s.value)
                              );
                            }
                            if (localStorage.getItem("Role") === "1" && acaid !== "") {
                              temp1.append("academy", acaid.value);
                            }
                            promotestudents(temp1).then((res) => {
                              if (res.status === true) {
                                setStuList(res.data);
                                setLoading(false);
                                toast.success(res.message);
                                setAcaID("");
                                setFYear("");
                                setFClass("");
                                setFSection("");
                                setFStudent([]);
                                setStudentOptions([]);
                                setTYear("");
                                setTClass("");
                                setTSection("");
                                setErrmsg("");
                              } else {
                                setLoading(false);
                                toast.error(res.message);
                              }
                            });
                          }
                        });
                      } else {
                        Swal.fire({
                          html: "<h3>No Student Found</h3>",
                          icon: "warning",
                          showCancelButton: false,
                          confirmButtonColor: "#19b159",
                          confirmButtonText: "Ok",
                          allowOutsideClick: false,
                        });
                      }
                    }
                  });
                } else {
                  setErrmsg("Please Select To Section");
                }
              } else {
                setErrmsg("Please Select To Class");
              }
            } else {
              setErrmsg("Please Select To Year");
            }
          } else {
            setErrmsg("Please Select From Section");
          }
        } else {
          setErrmsg("Please Select From Class");
        }
      } else {
        setErrmsg("Please Select From Year");
      }
    }
  }

  function subAlumni(e) {
    e.preventDefault();
    setErrmsg("");
    if (localStorage.getItem("Role") === "1" && acaid === "") {
      setErrmsg("Please Select Academy"); return;
    }
    if (!fyear) { setErrmsg("Please Select From Year"); return; }
    if (!fclass) { setErrmsg("Please Select From Class"); return; }
    if (!fsection) { setErrmsg("Please Select From Section"); return; }

    const temp = new FormData();
    temp.append("year", fyear);
    temp.append("class", fclass);
    temp.append("section", fsection);
    if (localStorage.getItem("Role") === "1" && acaid !== "") {
      temp.append("academy", acaid.value);
    }
    studentfilter(temp).then((res) => {
      if (res.status === true && res.data.details.length > 0) {
        const allStudents = res.data.details;
        const targets = fstudent.length > 0
          ? allStudents.filter(s => fstudent.some(f => f.value === s.id))
          : allStudents;

        Swal.fire({
          html: `<h3>Move to Alumni?</h3><br/><h4>Total Students: ${targets.length}</h4>`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#6259ca",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Move",
          allowOutsideClick: false,
        }).then(async (result) => {
          if (result.isConfirmed) {
            setLoading(true);
            const today = new Date().toISOString().split("T")[0];
            let failed = 0;
            for (const stu of targets) {
              const d = new FormData();
              d.append("stu_id", stu.id);
              d.append("user_id", localStorage.getItem("UID"));
              d.append("year", fyear);
              d.append("class", fclass);
              d.append("section", fsection);
              d.append("left_date", today);
              d.append("conduct", "Good");
              d.append("reason", "Alumni");
              d.append("remark", "");
              d.append("promote", 1);
              d.append("tc_no", "");
              if (localStorage.getItem("Role") === "1" && acaid !== "") {
                d.append("academy", acaid.value);
              }
              await studentleft(d).then((res) => {
                if (res.status !== true) failed++;
              });
            }
            setLoading(false);
            if (failed === 0) {
              toast.success(`${targets.length} student(s) moved to Alumni successfully`);
            } else {
              toast.error(`${failed} student(s) failed to move`);
            }
            setFYear(""); setFClass(""); setFSection("");
            setFStudent([]); setStudentOptions([]);
            setIsAlumni(false); setErrmsg("");
          }
        });
      } else {
        Swal.fire({ html: "<h3>No Student Found</h3>", icon: "warning", confirmButtonText: "Ok" });
      }
    });
  }

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listyear(e);
    } else {
      setAcaID("");
      listyear("");
    }
  }

  function listyear(aid) {
    setAList([]);
    setFYear("");
    setTYear("");
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    stuacademicyearlist(temp).then((res) => {
      if (res.status === true) {
        setAList(res.data);
      }
    });
  }

  const columnDefs = [
    {
      headerName: "Student",
      field: "student_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Username",
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Academic Year",
      field: "year_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Class",
      field: "class_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Section",
      field: "section_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Promote Student</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Students</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Promote Student
          </li>
        </ol>
      </div>
      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading && (
        <div className="content-body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="text-center">
                  <p className="text-danger">
                    Note: Promotion must be done in reverse order starting from higher classes (XII → XI → X). Promotion from lower to higher classes (I → II) is not allowed because those class records already exist in the system.
                  </p>
                </div>
              </div>
              <div className="col-xl-4">
                <div className="card">
                  <div className="card-header">
                    <h2 className="main-content-title tx-24 mg-b-5">
                      From Academic Year
                    </h2>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-12 col-sm-12">
                        {localStorage.getItem("Role") === "1" && (
                          <div className="mb-3">
                            <label className="form-label">
                              Select Academy{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <Select
                              className="default-select"
                              placeholder="Select Academy"
                              value={acaid}
                              options={aclist}
                              onChange={handleAcademy}
                              isSearchable={true}
                              isClearable
                              hidden
                            />
                          </div>
                        )}

                        <div className="mb-3">
                          <label className="form-label">
                            From Year<span className="text-danger"> *</span>
                          </label>
                          <select
                            className="default-select  form-control wide"
                            value={fyear}
                            onChange={(e) => setFYear(e.target.value)}
                          >
                            <option value="" disabled>
                              Select From Year
                            </option>
                            {alist.map((item, i) => {
                              return (
                                <option value={item.id} key={i}>
                                  {item.aca_year}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            From Class <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="default-select  form-control wide"
                            value={fclass}
                            onChange={(e) => setFClass(e.target.value)}
                          >
                            <option value="" disabled>
                              Select From Class
                            </option>
                            {classList.map((item, i) => {
                              return (
                                <option value={item.id} key={i}>
                                  {item.class_name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            From Section <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="default-select  form-control wide"
                            value={fsection}
                            onChange={(e) => setFSection(e.target.value)}
                          >
                            <option value="" disabled>
                              Select From Section
                            </option>
                            {seclist.map((item, i) => {
                              return (
                                <option value={item.id} key={i}>
                                  {item.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        {studentOptions.length > 0 && (
                          <div className="mb-3">
                            <label className="form-label">
                              Select Student(s){" "}
                              <span className="text-muted tx-12">(Optional)</span>
                            </label>
                            <Select
                              className="default-select"
                              placeholder="All Students"
                              value={fstudent}
                              options={studentOptions}
                              onChange={(selected) => setFStudent(selected || [])}
                              isSearchable={true}
                              isClearable
                              isMulti
                            />
                          </div>
                        )}
                        <div className="mb-3">
                          <div className="form-check d-flex align-items-center gap-2">
                            <input
                              className="form-check-input mt-0"
                              type="checkbox"
                              id="alumniCheck"
                              checked={isAlumni}
                              onChange={(e) => setIsAlumni(e.target.checked)}
                            />
                            <label className="form-check-label mb-0" htmlFor="alumniCheck">
                              Move to Alumni
                            </label>
                          </div>
                          {isAlumni && (
                            <small className="text-danger">Selected students will be moved to the alumni list and deactivated.</small>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {!isAlumni && <div className="col-xl-4">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <img
                        src={require("../../../assets/images/right arrow.jpg")}
                        alt="arrow"
                      />
                    </div>
                  </div>
                </div>
              </div>}
              {!isAlumni && <div className="col-xl-4">
                <div className="card">
                  <div className="card-header">
                    <h2 className="main-content-title tx-24 mg-b-5">
                      To Academic Year
                    </h2>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-12 col-sm-12">
                        {localStorage.getItem("Role") === "1" && (
                          <div className="mb-3">
                            <label className="form-label">
                              Select Academy{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <Select
                              className="default-select"
                              placeholder="Select Academy"
                              value={acaid}
                              options={aclist}
                              onChange={handleAcademy}
                              isSearchable={true}
                              isClearable
                              hidden
                            />
                          </div>
                        )}
                        <div className="mb-3">
                          <label className="form-label">
                            To Year<span className="text-danger"> *</span>
                          </label>
                          <select
                            className="default-select  form-control wide"
                            value={tyear}
                            onChange={(e) => setTYear(e.target.value)}
                          >
                            <option value="" disabled>
                              Select TO Year
                            </option>
                            {alist.map((item, i) => {
                              return (
                                <option value={item.id} key={i}>
                                  {item.aca_year}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            To Class <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="default-select  form-control wide"
                            value={tclass}
                            onChange={(e) => setTClass(e.target.value)}
                          >
                            <option value="" disabled>
                              Select To Class
                            </option>
                            {classList.map((item, i) => {
                              return (
                                <option value={item.id} key={i}>
                                  {item.class_name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            To Section <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="default-select  form-control wide"
                            value={tsection}
                            onChange={(e) => setTSection(e.target.value)}
                          >
                            <option value="" disabled>
                              Select To Section
                            </option>
                            {seclist.map((item, i) => {
                              return (
                                <option value={item.id} key={i}>
                                  {item.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}

            </div>
            {errmsg !== "" && <span className="text-danger">{errmsg}</span>}
            <div className="res-right mt-2 me-4">
              <button
                className={`btn ${isAlumni ? "btn-info" : "btn-success"}`}
                onClick={isAlumni ? subAlumni : subpromote}
              >
                {isAlumni ? "Move to Alumni" : "Submit"}
              </button>
            </div>
            <hr />
            <h4>Promoted Students</h4>
            <div className="card">
              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={stuList}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default Promotestudent;
